export const ADD_AUTOMATIC_EMAIL = 'ADD_AUTOMATIC_EMAIL';
export const REMOVE_AUTOMATIC_EMAIL = 'REMOVE_AUTOMATIC_EMAIL';
export const SELECT_AUTOMATIC_EMAIL = 'SELECT_AUTOMATIC_EMAIL';
export const UPDATE_AUTOMATIC_EMAIL = 'UPDATE_AUTOMATIC_EMAIL';

export const ADD_AUTOMATIC_NOTE = 'ADD_AUTOMATIC_NOTE';
export const REMOVE_AUTOMATIC_NOTE = 'REMOVE_AUTOMATIC_NOTE';
export const SELECT_AUTOMATIC_NOTE = 'SELECT_AUTOMATIC_NOTE';
export const UPDATE_AUTOMATIC_NOTE = 'UPDATE_AUTOMATIC_NOTE';
